import { normalizeFiltrosAcessoExternoParaDruid } from "../common/FiltroUtil";
// cubos permitidos para acesso externo
export const ACESSO_EXTERNO_CUBOS = ["cubo_teleconsultoria"];
// atributos permitidos para acesso externo
export const ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS_TIMESTAMP_MS = [
    "data_teleconsultoria", "data_solicitacao", "data_atendimento", "data_avaliacao", "data_leitura"
];
export const ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS = [
    ...ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS_TIMESTAMP_MS,
    "orientacao_especifica", "qnt"
];
const CUBO_RULES = {
    "cubo_teleconsultoria": {
        acessoExterno: {
            atributos: ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS,
        },
        dateFields: ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS_TIMESTAMP_MS,
    }
};
export const buscarRegrasAcessoExterno = (cubo) => {
    const rules = CUBO_RULES[cubo];
    return rules === null || rules === void 0 ? void 0 : rules.acessoExterno;
};
export const normalizeFiltros = (filtros) => {
    return normalizeFiltrosAcessoExternoParaDruid(filtros, ACESSO_EXTERNO_TELECONSULTORIA_ATRIBUTOS_TIMESTAMP_MS);
};
